import {
  ApiGetHook,
  ApiMutateHook,
  useApiGet,
  useApiMutate,
} from "@skanska/vsa-client-auth";
import { ApiEndpoints } from "../models/ApiEndpoints";
import { ApiMethods } from "../models/ApiMethods";
import {
  Chapter,
  CreateChapterRequest,
  UpdateChapterRequest,
} from "../models/Chapter";

export function useChapterGet(id: string): ApiGetHook<Chapter> {
  return useApiGet<Chapter>(ApiEndpoints.Chapters, id, `chapter-${id}`);
}

export function useChaptersGetAll(): ApiGetHook<Array<Chapter>> {
  return useApiGet<Array<Chapter>>(ApiEndpoints.Chapters);
}

export function useCreateChapter(): ApiMutateHook<
  Chapter,
  CreateChapterRequest
> {
  return useApiMutate<Chapter, CreateChapterRequest>(
    ApiEndpoints.Chapters,
    ApiMethods.Post,
    null,
    null,
    [ApiEndpoints.Chapters]
  );
}

export function useUpdateChapter(
  id: string
): ApiMutateHook<Chapter, UpdateChapterRequest> {
  return useApiMutate<Chapter, UpdateChapterRequest>(
    ApiEndpoints.Chapters,
    ApiMethods.Patch,
    id,
    null,
    [ApiEndpoints.Chapters, `chapter-${id}`]
  );
}

export function useDeleteChapter(id: string): ApiMutateHook<void, void> {
  return useApiMutate<void, void>(
    ApiEndpoints.Chapters,
    ApiMethods.Delete,
    id,
    null,
    [ApiEndpoints.Chapters, `chapter-${id}`]
  );
}
